import { i18n } from 'i18n';

export const ROUTE_PATH = '/notifications';
export const TITLE = i18n._('Notifications');
